<template>
  <div class="card" style="width: 1500px;max-width:100%;">
    <div class="card-modal" style="overflow:auto;max-height:700px;">
      <b-loading
        :is-full-page="true"
        v-model="loading"
        :can-cancel="false"
      ></b-loading>

      <header class="modal-card-head">
        <p class="modal-card-title">{{ headerText }}</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <div>
          <span class="is-size-4">Category</span><br /><br />
          <b-field>
            <b-radio-button
              v-model="rule.category"
              native-value="air"
              type="is-primary"
              :disabled="type != 'air'"
            >
              <b-icon icon="airplane"></b-icon>
              <span>Air</span>
            </b-radio-button>

            <b-radio-button
              v-model="type"
              native-value="car"
              type="is-primary"
              :disabled="type != 'car'"
            >
              <b-icon icon="car"></b-icon>
              <span>Car</span>
            </b-radio-button>
            <b-radio-button
              v-model="type"
              native-value="hotel"
              type="is-primary"
              :disabled="type != 'hotel'"
            >
              <b-icon icon="bed"></b-icon>
              <span>Hotel</span>
            </b-radio-button>
          </b-field>
        </div>
        <br />
        <div>
          <span class="is-size-4">Trigger this rule if..</span><br /><br />
          <div>
            <CustomCondition
              v-for="(item, index) in rule.conditions"
              :key="item.uid ? item.uid : item.id"
              :type="type"
              :index="index"
              mode="view"
              :condition="item"
              @remove="remove(index)"
            />
          </div>

          <br />
          <b-button class="is-primary" outlined @click="addCondition"
            >Add Condition</b-button
          >
        </div>
        <br />
        <div v-if="rule.conditions.length>1">
              <span class="is-size-4"
                >How many conditions should be met to trigger this rule?</span
              ><br /><br />
              <b-field>
                <b-radio-button
                  v-model="rule.triggerWhen"
                  native-value="any"
                  type="is-primary"
                >
                  <span>At least one</span>
                </b-radio-button>
                <b-radio-button
                  v-model="rule.triggerWhen"
                  native-value="all"
                  type="is-primary"
                >
                  <span>All of them</span>
                </b-radio-button>
              </b-field>
            </div>

            <div v-else>
              <input type="hidden" value="all" v-model="rule.triggerWhen" />
            </div>
            <br />

            <div>
              <span class="is-size-4"
                >Rule Actions</span
              ><br /><br />
              <b-field>
                <b-radio-button
                  v-model="rule.actionType"
                  native-value="Inherit"
                  type="is-primary"
                >
                  <span>Apply same actions as overall policy</span>
                </b-radio-button>
                <b-radio-button
                  v-model="rule.actionType"
                  native-value="Custom"
                  type="is-primary"
                >
                  <span>Configure custom actions</span>
                </b-radio-button>
                
              </b-field>
            </div>
            <br>
            <Actions v-if="rule.actionType=='Custom'"  :travelPolicy="null"   @actionsData="getActionData" :approvalLevel="rule.approvalLevel" :visibility="rule.visibility" :notifications="JSON.parse(rule.actionsJson)" />


        <br />
      </section>
      <footer class="modal-card-foot">
        <b-button label="Close" @click="$emit('close')" />
        <b-button
          :disabled="!isFormValid"
          @click="submit()"
          class="button is-primary is-wide"
        >
          Save</b-button
        >
      </footer>
    </div>
  </div>
</template>

<script>
import CustomCondition from "./CustomCondition.vue";
import Actions from "./Actions.vue";

export default {
  name: "CustomRuleModal",
  components: {
    CustomCondition,
    Actions
  },
  props: {
    mode: String,
    type: String,
    rules: Object,
    
  },
  data() {
    return {
      loading: false,
      showConditionBuilder: false,
      rule: JSON.parse(JSON.stringify(this.rules)) 
    };
  },
  methods: {
    addCondition() {
      this.rule.conditions.push({
        mode: "edit",
        id: "",
        uid: "Cdn" + Math.random() + new Date().getTime(),
        message: "",
        name: "",
        attribute: {
          id: "",
          name: "",
        },
        comparison: {
          operator: "",
          value: null,
          valueUnits: "",
        },
      });
    },
    remove(val) {
      this.rule.conditions.splice(val, 1);
    },

    getActionData(val) {
        if(this.rule.actionType == 'Custom'){
          
            this.rule.approvalLevel = val.approvalLevel;
            this.rule.visibility = val.visibility;
            this.rule.approvalRequired = (val.approvalLevel=='hard'||val.approvalLevel=='soft')?'Yes':'No';
            this.rule.actionsJson = JSON.stringify(val.notifications);
    
        }

    },

    submit() {
        this.$emit('save',this.rule);
        this.$emit('close');
      
    },

    
  },
  mounted() {},
  computed: {
    isFormValid() {


        var noOfConditions = this.rule.conditions
        var ruleActions= this.rule.actionType
        var conditionsSaved=this.rule.conditions.filter(e => e.mode == 'edit').length > 0;
      return (noOfConditions && ruleActions && !conditionsSaved);
    },

    headerText() {
      if (this.mode == "new") return "Add " + "Rule";
      else return "Edit " + "Rule";
    },
  },
};
</script>

<style scoped>
.is-less-bottom {
  margin-bottom: -20px;
}
</style>